import { inlineFootnoteExtensions } from '@blocksuite/hive-inline-footnote';
import { inlineLatexExtensions } from '@blocksuite/hive-inline-latex';
import { inlineLinkExtensions } from '@blocksuite/hive-inline-link';
import { inlineMentionExtensions } from '@blocksuite/hive-inline-mention';
import { inlineReferenceExtensions } from '@blocksuite/hive-inline-reference';
import type { HiveTextAttributes } from '@blocksuite/hive-shared/types';
import {
  type InlineRootElement,
  InlineSpecExtension,
} from '@blocksuite/std/inline';
import type { ExtensionType } from '@blocksuite/store';
import { html } from 'lit';
import { z } from 'zod';

export type HiveInlineRootElement = InlineRootElement<HiveTextAttributes>;

export const BoldInlineSpecExtension =
  InlineSpecExtension<HiveTextAttributes>({
    name: 'bold',
    schema: z.literal(true).optional().nullable().catch(undefined),
    match: delta => {
      return !!delta.attributes?.bold;
    },
    renderer: ({ delta }) => {
      return html`<hive-text .delta=${delta}></hive-text>`;
    },
  });

export const ItalicInlineSpecExtension =
  InlineSpecExtension<HiveTextAttributes>({
    name: 'italic',
    schema: z.literal(true).optional().nullable().catch(undefined),
    match: delta => {
      return !!delta.attributes?.italic;
    },
    renderer: ({ delta }) => {
      return html`<hive-text .delta=${delta}></hive-text>`;
    },
  });

export const UnderlineInlineSpecExtension =
  InlineSpecExtension<HiveTextAttributes>({
    name: 'underline',
    schema: z.literal(true).optional().nullable().catch(undefined),
    match: delta => {
      return !!delta.attributes?.underline;
    },
    renderer: ({ delta }) => {
      return html`<hive-text .delta=${delta}></hive-text>`;
    },
  });

export const StrikeInlineSpecExtension =
  InlineSpecExtension<HiveTextAttributes>({
    name: 'strike',
    schema: z.literal(true).optional().nullable().catch(undefined),
    match: delta => {
      return !!delta.attributes?.strike;
    },
    renderer: ({ delta }) => {
      return html`<hive-text .delta=${delta}></hive-text>`;
    },
  });

export const CodeInlineSpecExtension =
  InlineSpecExtension<HiveTextAttributes>({
    name: 'code',
    schema: z.literal(true).optional().nullable().catch(undefined),
    match: delta => {
      return !!delta.attributes?.code;
    },
    renderer: ({ delta }) => {
      return html`<hive-text .delta=${delta}></hive-text>`;
    },
  });

export const BackgroundInlineSpecExtension =
  InlineSpecExtension<HiveTextAttributes>({
    name: 'background',
    schema: z.string().optional().nullable().catch(undefined),
    match: delta => {
      return !!delta.attributes?.background;
    },
    renderer: ({ delta }) => {
      return html`<hive-text .delta=${delta}></hive-text>`;
    },
  });

export const ColorInlineSpecExtension =
  InlineSpecExtension<HiveTextAttributes>({
    name: 'color',
    schema: z.string().optional().nullable().catch(undefined),
    match: delta => {
      return !!delta.attributes?.color;
    },
    renderer: ({ delta }) => {
      return html`<hive-text .delta=${delta}></hive-text>`;
    },
  });

export const InlineSpecExtensions: ExtensionType[] = [
  BoldInlineSpecExtension,
  ItalicInlineSpecExtension,
  UnderlineInlineSpecExtension,
  StrikeInlineSpecExtension,
  CodeInlineSpecExtension,
  BackgroundInlineSpecExtension,
  ColorInlineSpecExtension,
  ...inlineLinkExtensions,
  ...inlineReferenceExtensions,
  ...inlineLatexExtensions,
  ...inlineFootnoteExtensions,
  ...inlineMentionExtensions,
];
